export function formatShareRow(analysis) {
  const length = analysis.tiles.length;
  if (length === 0) return " -";
  const markers = Array(length).fill(analysis.valid ? "🟥" : "⬜").join("|");
  return `${markers} ${analysis.valid && analysis.score > 0 ? length : "-"}`;
}

export function dailyShareSummary(user, entries) {
  if (!user || !entries) return null;
  const keys = ["easy", "medium", "hard"];
  if (!keys.every(key => Number.isFinite(entries[key]?.score) && entries[key].score >= 0)) return null;
  const scores = Object.fromEntries(keys.map(key => [key, entries[key].score]));
  return { ...scores, total: keys.reduce((sum, key) => sum + scores[key], 0) };
}

export function formatDailyShareText(dateLabel, scores, url) {
  return [
    "totonoeyo ととのえよう toh-toh-no-eh-yo",
    dateLabel,
    "",
    `${scores.easy}   easy 松`,
    `${scores.medium}   medium 竹`,
    `${scores.hard}   hard 梅`,
    "-----",
    `${scores.total}   daily total 本日計`,
    "-----",
    "",
    url
  ].join("\n");
}
